// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__qHtY3","content":"PrivacyPolicy_content__PK8vz"};